import { ReportParameterTypeEnumSchema } from "@/Enums/ReportParameterType";
import { z } from "zod";
import { ReportParameterListValueExecutionDtoSchema } from "./ReportParameterListValueExecutionDto";

export const ReportParameterExecuteDtoSchema = z.object({
    reportParameterId: z.string(),
    reportId: z.number(),
    name: z.string().nullable(),
    description: z.string().nullable(),
    type: ReportParameterTypeEnumSchema,
    allowMultiselect: z.boolean().nullable(),
    isOptional: z.boolean(),
    allowSearch: z.boolean().nullable(),
    values: z.array(ReportParameterListValueExecutionDtoSchema).nullable(),
    selectableValues: z.array(ReportParameterListValueExecutionDtoSchema).nullable(),
});

export type ReportParameterExecuteDto = z.infer<typeof ReportParameterExecuteDtoSchema>;